import { SvgIcon, SvgIconProps } from "@material-ui/core";
import React from "react";

export const Balanced = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.0714 7.05991 19.4439 11 19.9378V4.06223C7.05991 4.55609 4 7.92859 4 12ZM17.9763 17.3118C16.7189 18.7249 14.9694 19.6909 13 19.9378V17.3118H17.9763ZM19.2815 15.3118H13V13H19.9378C19.8357 13.8147 19.6105 14.5917 19.2815 15.3118ZM19.9378 11C19.8357 10.1853 19.6105 9.40829 19.2815 8.68815L13 8.68815V11H19.9378ZM13 6.68815L17.9763 6.68815C16.7189 5.27512 14.9694 4.30908 13 4.06223V6.68815Z"
      fill="currentColor"
    />
  </SvgIcon>
);
